import { Container } from "@sainsburys-tech/luna-grid"
import { Display3 } from "@sainsburys-tech/luna-typography"
import EnforcementContacts from "../components/EnforcementContacts/EnforcementContacts"
import ReportEnforcementContact from "../components/ReportEnforcementContact"

const EnforcementContactsPage = () => {

  const pageTitle = () => {
    return (
      <Container className="ln-u-padding-bottom*4" size="xs">
        <div>
          <Display3 id="s-page-title" className="s-page-title ln-u-padding-left*2 ln-u-display-inline-block">
            Reported enforcement contacts
          </Display3>
        </div>
      </Container>
    )
  }

  return (
    <div className="s-reported-enforcement-contacts-dashboard ln-u-1/1">
      
      <ReportEnforcementContact />

      {pageTitle()}

      <Container className="s-reported-enforcement-contacts" size="xs">
        <EnforcementContacts />
      </Container>
    </div>
  )
}

export default EnforcementContactsPage